/** Trashed boards shown before "Show all" (OIL-84: thousands of rows made the page crawl). */
export const TRASH_PREVIEW = 20;

/** Newest first; only the first TRASH_PREVIEW unless expanded. */
export function visibleTrash<T extends { deletedAt?: string | null | undefined }>(
  boards: readonly T[],
  expanded: boolean,
): { shown: T[]; hidden: number } {
  const sorted = [...boards].sort((a, b) => (b.deletedAt ?? '').localeCompare(a.deletedAt ?? ''));
  if (expanded || sorted.length <= TRASH_PREVIEW) return { shown: sorted, hidden: 0 };
  return { shown: sorted.slice(0, TRASH_PREVIEW), hidden: sorted.length - TRASH_PREVIEW };
}
